import { useCallback, useEffect, useState } from 'react';
import { getTnCStatus, acceptTnC } from 'utils/apis/tnc';

export const useTnCGate = (isAuth, user) => {
  const [termsTncVisible, setTermsTncVisible] = useState(false);
  const [acceptError, setAcceptError] = useState(null);
  const [isAccepting, setIsAccepting] = useState(false);

  const checkStatus = useCallback(async () => {
    if (!isAuth || !user || typeof user !== 'object' || !user._id) {
      setTermsTncVisible(false);
      return;
    }

    try {
      const response = await getTnCStatus();
      const status = response.data;

      if (status && status.requiresAcceptance) {
        setTermsTncVisible(true);
      } else {
        setTermsTncVisible(false);
      }
    } catch {
      setTermsTncVisible(false);
    }
  }, [isAuth, user]);

  useEffect(() => {
    checkStatus();
  }, [checkStatus]);

  useEffect(() => {
    if (!isAuth || !user || !user._id) {
      return undefined;
    }

    const onFocus = () => {
      checkStatus();
    };

    window.addEventListener('focus', onFocus);
    return () => window.removeEventListener('focus', onFocus);
  }, [isAuth, user, checkStatus]);

  const handleAccept = useCallback(async () => {
    setIsAccepting(true);
    setAcceptError(null);

    try {
      const response = await acceptTnC();
      const status = response.data;

      if (status && !status.requiresAcceptance) {
        setTermsTncVisible(false);
      } else {
        setAcceptError('Acceptance could not be confirmed. Please try again.');
        throw new Error('requiresAcceptance still true');
      }
    } catch (err) {
      setAcceptError(err.message || 'Failed to save acceptance. Please try again.');
      throw err;
    } finally {
      setIsAccepting(false);
    }
  }, []);

  return {
    termsTncVisible,
    handleAccept,
    acceptError,
    isAccepting,
    clearAcceptError: () => setAcceptError(null)
  };
};
